import React, {useEffect} from 'react'
import RatingIcon from '../../assets/icons/rating.png'
import { FaGlobe } from 'react-icons/fa'
import CourseInfoCard from './Card/CourseInfoCard'
import DataScienceInfo from './Card/DataScienceInfo'

const DataScience = () => {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [])

  return (
    <div className="course-info">
      <div className="course-hero text-white px-md-5 data-science">
        <p>Engineering &gt; Software &gt; Data Science</p>
        <h1>Data Science Program</h1>
        <div className="d-flex flex-row justify-content-start align-items-center">
          <span>4.8</span>
          <img src={RatingIcon} alt="Rating" />
        </div>
        <p>
          <FaGlobe /> <i>English</i>
        </p>
      </div>
      <div className="d-flex flex-column flex-md-row row">
        <div className="col-md-8">
          <DataScienceInfo />
        </div>
        <div className="col-md-4">
          <CourseInfoCard />
        </div>
      </div>
    </div>
  )
}

export default DataScience
